import { TOMATO_RED } from '../styles/theme';
import { ElectoralArea, ElectoralDataResponse, ElectoralDistrict, ElectoralWard } from './electoral';
import { PropertyStyleGroupSerializer } from './property';

export interface MarketTrendsAveragePriceResponse {
  term: string;
  label: string | null;
  value: number | null;
  change: number | null;
  type: string | null;
}

export const TREND_TYPES = ['OUTCODE', 'ELECTORAL_AREA', 'COUCIL_AREA', 'COUNTRY'] as const;

export type PriceIndexLevel = (typeof TREND_TYPES)[number];

export interface MarketTrendPointFigure {
  value: number | null;
  change: number | null;
  rangeStart: string;
}

export interface MarketTrendDataPointsResponse {
  points: Record<string, MarketTrendPointFigure>;
  level: PriceIndexLevel;
  label: string | null;
  filterType: string | null;
  filter: string | null;
}

export interface MarketTrendsResponse {
  electoralWard?: ElectoralWard;
  electoralArea?: ElectoralArea;
  coucilArea?: ElectoralDistrict;
  bedrooms?: number;
  propertyStyleGroup?: PropertyStyleGroupSerializer;
  startTime: string;
  endTime: string;
  data: MarketTrendDataPointsResponse[];
  averageAreaPrice?: MarketTrendsAveragePriceResponse;
  averageAreaPriceGrowth?: MarketTrendsAveragePriceResponse;
  form?: ElectoralDataResponse;
  averagePriceGrowth: MarketTrendsAveragePriceResponse[] | null;
}

export interface MarketTrendsAvgPrice {
  label: MarketTrendsAveragePriceResponse['label'];
  change: MarketTrendPointFigure['change'];
}

export type MarketTrendsAvgPriceData = {
  [K in PriceIndexLevel]: MarketTrendsAvgPrice | null;
};

export const MARKET_TREND_COLOURS: Record<PriceIndexLevel, string> = {
  COUCIL_AREA: '#823B8F',
  COUNTRY: '#7EC07C',
  ELECTORAL_AREA: '#33A3DD',
  OUTCODE: TOMATO_RED,
};

export const MARKET_TRENDS_LINE_COLOURS = [
  MARKET_TREND_COLOURS.OUTCODE,
  MARKET_TREND_COLOURS.ELECTORAL_AREA,
  MARKET_TREND_COLOURS.COUCIL_AREA,
  MARKET_TREND_COLOURS.COUNTRY,
  '#2A5184 ',
  '#B06BA9',
];

export type MarketTrendsLabels = Record<PriceIndexLevel, string>;

export const DEFAULT_TREND_SELECTED: PriceIndexLevel[] = ['OUTCODE'];
